module.exports = __webpack_public_path__ + "static/media/www.noho.fi.c65ec341.png";